export default function Support() {
  return (
    <div>
      <h2 className="text-2xl font-bold mb-6">サポート</h2>

      <div className="bg-white rounded-lg shadow border p-6 mb-6">
        <h3 className="font-semibold text-lg mb-4">お問い合わせ</h3>

        <div className="space-y-3 text-sm">
          <div className="flex items-start gap-3">
            <span className="text-xl">📧</span>
            <div>
              <p className="font-medium">メール</p>
              <p className="text-slate-600">
                <a href="mailto:support@cogneolink.jp" className="text-blue-600 hover:underline">
                  support@cogneolink.jp
                </a>
              </p>
              <p className="text-xs text-slate-500">営業時間内 2時間以内に返信</p>
            </div>
          </div>

          <div className="flex items-start gap-3">
            <span className="text-xl">📞</span>
            <div>
              <p className="font-medium">電話（プロプラン以上）</p>
              <p className="text-slate-600">03-XXXX-XXXX</p>
              <p className="text-xs text-slate-500">平日 10:00-18:00</p>
            </div>
          </div>

          <div className="flex items-start gap-3">
            <span className="text-xl">⏰</span>
            <div>
              <p className="font-medium">サポート対応時間</p>
              <p className="text-slate-600">平日 10:00-18:00（土日祝休）</p>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-white rounded-lg shadow border p-6">
        <h3 className="font-semibold text-lg mb-4">よくあるご質問</h3>

        <div className="space-y-4">
          <FAQ
            q="連携が失敗していると通知が来ました"
            a="Craval側で原因調査を開始しています。1営業日以内にご連絡いたします。
               お客様側での対応は不要です。"
          />
          <FAQ
            q="新しい連携先システムを追加したい"
            a="「設定変更依頼」ページから新シナリオ追加のご依頼をお送りください。
               追加見積もり後、3〜10営業日で構築・検収となります。"
          />
          <FAQ
            q="今月の請求金額を確認したい"
            a="現状、請求は別途メールでお送りしています。
               請求書ポータルは今後実装予定です。"
          />
          <FAQ
            q="一時的に連携を止めたい"
            a="「設定変更依頼」から「一時停止」をお選びください。
               停止期間中も基本料金は発生します（最大3ヶ月まで）。"
          />
        </div>
      </div>
    </div>
  );
}

function FAQ({ q, a }: { q: string; a: string }) {
  return (
    <details className="border rounded p-3">
      <summary className="font-medium cursor-pointer">{q}</summary>
      <p className="text-sm text-slate-600 mt-2 whitespace-pre-line">{a}</p>
    </details>
  );
}
